var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    width: 40.6667,
    height: 40.6667,
    rx: 8.33333,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_17677",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8.33301,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_17677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3077 28.8327C15.8091 28.8327 15.3831 28.6562 15.0298 28.303C14.6766 27.9497 14.5 27.5237 14.5 27.025V14.3327H13.5V12.8327H18V11.9482H24V12.8327H28.5V14.3327H27.5V27.025C27.5 27.5302 27.325 27.9577 26.975 28.3077C26.625 28.6577 26.1974 28.8327 25.6923 28.8327H16.3077ZM26 14.3327H16V27.025C16 27.1148 16.0288 27.1886 16.0865 27.2462C16.1442 27.3039 16.2179 27.3327 16.3077 27.3327H25.6923C25.7692 27.3327 25.8398 27.3007 25.9038 27.2365C25.9679 27.1725 26 27.102 26 27.025V14.3327ZM18.404 25.3327H19.9037V16.3327H18.404V25.3327ZM22.0962 25.3327H23.596V16.3327H22.0962V25.3327Z",
    fill: "#F46530"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.201451bb17e7a8782dbb33d27ff9f699.svg";
export { ForwardRef as ReactComponent };